import { TranslationService } from 'projects/dop-core/src/public-api';
import { INVALIDDATE, ORDER } from 'src/app/features/guided-order/samples/constants/sample-constants';
import { Injectable } from '@angular/core';
import { FieldType } from '../models/additional-field.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Unit } from '../models/specification/units.model';
import { default as states } from 'src/app/shared/data/us-state-info.json';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

  getDateFormat(culture: string): string {
    const formats: { [key: string]: string; } = this.getDateFormats();
    let dateFormat = formats[culture] || 'dd/MM/yyyy';
    dateFormat = (dateFormat.replace('yyyy', 'yy')).replace('MM', 'mm');
    return dateFormat;
  }

  getDateOriginalFormat(culture: string): string {
    const formats: { [key: string]: string; } = this.getDateFormats();
    const dateFormat = formats[culture] || 'dd/MM/yyyy';
    return dateFormat;
  }

  handleHttpError(error: HttpErrorResponse, scope: string, isFromFavOrSubmittedOrder = false) {
    let response = '';
    if (error instanceof HttpErrorResponse &&
      ((error.status === 404 && error.error.title === 'Error_Lab_Site_Code_Not_Found') ||
        (error.status === 400 && error.error.title === 'Error_All_Codes_Are_Utilized'))) {
      response = scope === ORDER ? 'vbeiGlcLabsiteOrderError' :
        (isFromFavOrSubmittedOrder ? 'vbeiGlcLabsiteSampleCodeError' : 'vbeiGlcLabsiteSampleError');
    } else if (error instanceof HttpErrorResponse && (error.status === 500 || error.status === 404)) {
      response = 'vbeiTechnicalError';
    }
    return response;
  }

  public getDateFormats() {
    const formats: { [key: string]: string; } = {
      'ar-SA': 'dd/MM/yy',
      'bg-BG': 'dd.M.yyyy',
      'ca-ES': 'dd/MM/yyyy',
      'zh-TW': 'yyyy/M/d',
      'cs-CZ': 'd.M.yyyy',
      'da-DK': 'dd-MM-yyyy',
      'de-DE': 'dd.MM.yyyy',
      'el-GR': 'd/M/yyyy',
      'en-US': 'M/d/yyyy',
      'fi-FI': 'd.M.yyyy',
      'fr-FR': 'MM/dd/yyyy',
      'he-IL': 'dd/MM/yyyy',
      'hu-HU': 'yyyy. MM. dd',
      'is-IS': 'd.M.yyyy',
      'it-IT': 'dd/MM/yyyy',
      'ja-JP': 'yyyy/MM/dd',
      'ko-KR': 'yyyy-MM-dd',
      'nl-NL': 'd-M-yyyy',
      'nb-NO': 'dd.MM.yyyy',
      'pl-PL': 'yyyy-MM-dd',
      'pt-BR': 'd/M/yyyy',
      'ro-RO': 'dd.MM.yyyy',
      'ru-RU': 'dd.MM.yyyy',
      'hr-HR': 'd.M.yyyy',
      'sk-SK': 'd. M. yyyy',
      'sq-AL': 'yyyy-MM-dd',
      'sv-SE': 'yyyy-MM-dd',
      'th-TH': 'd/M/yyyy',
      'tr-TR': 'dd.MM.yyyy',
      'ur-PK': 'dd/MM/yyyy',
      'id-ID': 'dd/MM/yyyy',
      'uk-UA': 'dd.MM.yyyy',
      'be-BY': 'dd.MM.yyyy',
      'sl-SI': 'd.M.yyyy',
      'et-EE': 'd.MM.yyyy',
      'lv-LV': 'yyyy.MM.dd.',
      'lt-LT': 'yyyy.MM.dd',
      'fa-IR': 'MM/dd/yyyy',
      'vi-VN': 'dd/MM/yyyy',
      'hy-AM': 'dd.MM.yyyy',
      'az-Latn-AZ': 'dd.MM.yyyy',
      'eu-ES': 'yyyy/MM/dd',
      'mk-MK': 'dd.MM.yyyy',
      'af-ZA': 'yyyy/MM/dd',
      'ka-GE': 'dd.MM.yyyy',
      'fo-FO': 'dd-MM-yyyy',
      'hi-IN': 'dd-MM-yyyy',
      'ms-MY': 'dd/MM/yyyy',
      'kk-KZ': 'dd.MM.yyyy',
      'ky-KG': 'dd.MM.yy',
      'sw-KE': 'M/d/yyyy',
      'uz-Latn-UZ': 'dd/MM/yyyy',
      'tt-RU': 'dd.MM.yyyy',
      'pa-IN': 'dd-MM-yy',
      'gu-IN': 'dd-MM-yy',
      'ta-IN': 'dd-MM-yyyy',
      'te-IN': 'dd-MM-yy',
      'kn-IN': 'dd-MM-yy',
      'mr-IN': 'dd-MM-yyyy',
      'sa-IN': 'dd-MM-yyyy',
      'mn-MN': 'yy.MM.dd',
      'gl-ES': 'dd/MM/yy',
      'kok-IN': 'dd-MM-yyyy',
      'syr-SY': 'dd/MM/yyyy',
      'dv-MV': 'dd/MM/yy',
      'ar-IQ': 'dd/MM/yyyy',
      'zh-CN': 'yyyy/M/d',
      'de-CH': 'dd.MM.yyyy',
      'en-GB': 'dd/MM/yyyy',
      'es-MX': 'dd/MM/yyyy',
      'fr-BE': 'd/MM/yyyy',
      'it-CH': 'dd.MM.yyyy',
      'nl-BE': 'd/MM/yyyy',
      'nn-NO': 'dd.MM.yyyy',
      'pt-PT': 'dd-MM-yyyy',
      'sr-Latn-CS': 'd.M.yyyy',
      'sv-FI': 'd.M.yyyy',
      'az-Cyrl-AZ': 'dd.MM.yyyy',
      'ms-BN': 'dd/MM/yyyy',
      'uz-Cyrl-UZ': 'dd.MM.yyyy',
      'ar-EG': 'dd/MM/yyyy',
      'zh-HK': 'd/M/yyyy',
      'de-AT': 'dd.MM.yyyy',
      'en-AU': 'd/MM/yyyy',
      'es-ES': 'dd/MM/yyyy',
      'fr-CA': 'yyyy-MM-dd',
      'sr-Cyrl-CS': 'd.M.yyyy',
      'ar-LY': 'dd/MM/yyyy',
      'zh-SG': 'd/M/yyyy',
      'de-LU': 'dd.MM.yyyy',
      'en-CA': 'dd/MM/yyyy',
      'es-GT': 'dd/MM/yyyy',
      'fr-CH': 'dd.MM.yyyy',
      'ar-DZ': 'dd-MM-yyyy',
      'zh-MO': 'd/M/yyyy',
      'de-LI': 'dd.MM.yyyy',
      'en-NZ': 'd/MM/yyyy',
      'es-CR': 'dd/MM/yyyy',
      'fr-LU': 'dd/MM/yyyy',
      'ar-MA': 'dd-MM-yyyy',
      'en-IE': 'dd/MM/yyyy',
      'es-PA': 'MM/dd/yyyy',
      'fr-MC': 'dd/MM/yyyy',
      'ar-TN': 'dd-MM-yyyy',
      'en-ZA': 'yyyy/MM/dd',
      'es-DO': 'dd/MM/yyyy',
      'ar-OM': 'dd/MM/yyyy',
      'en-JM': 'dd/MM/yyyy',
      'es-VE': 'dd/MM/yyyy',
      'ar-YE': 'dd/MM/yyyy',
      'en-029': 'MM/dd/yyyy',
      'es-CO': 'dd/MM/yyyy',
      'ar-SY': 'dd/MM/yyyy',
      'en-BZ': 'dd/MM/yyyy',
      'es-PE': 'dd/MM/yyyy',
      'ar-JO': 'dd/MM/yyyy',
      'en-TT': 'dd/MM/yyyy',
      'es-AR': 'dd/MM/yyyy',
      'ar-LB': 'dd/MM/yyyy',
      'en-ZW': 'M/d/yyyy',
      'es-EC': 'dd/MM/yyyy',
      'ar-KW': 'dd/MM/yyyy',
      'en-PH': 'M/d/yyyy',
      'es-CL': 'dd-MM-yyyy',
      'ar-AE': 'dd/MM/yyyy',
      'es-UY': 'dd/MM/yyyy',
      'ar-BH': 'dd/MM/yyyy',
      'es-PY': 'dd/MM/yyyy',
      'ar-QA': 'dd/MM/yyyy',
      'es-BO': 'dd/MM/yyyy',
      'es-SV': 'dd/MM/yyyy',
      'es-HN': 'dd/MM/yyyy',
      'es-NI': 'dd/MM/yyyy',
      'es-PR': 'dd/MM/yyyy',
      'am-ET': 'd/M/yyyy',
      'tzm-Latn-DZ': 'dd-MM-yyyy',
      'iu-Latn-CA': 'd/MM/yyyy',
      'sma-NO': 'dd.MM.yyyy',
      'mn-Mong-CN': 'yyyy/M/d',
      'gd-GB': 'dd/MM/yyyy',
      'en-MY': 'd/M/yyyy',
      'prs-AF': 'dd/MM/yy',
      'bn-BD': 'dd-MM-yy',
      'wo-SN': 'dd/MM/yyyy',
      'rw-RW': 'M/d/yyyy',
      'qut-GT': 'dd/MM/yyyy',
      'sah-RU': 'MM.dd.yyyy',
      'gsw-FR': 'dd/MM/yyyy',
      'co-FR': 'dd/MM/yyyy',
      'oc-FR': 'dd/MM/yyyy',
      'mi-NZ': 'dd/MM/yyyy',
      'ga-IE': 'dd/MM/yyyy',
      'se-SE': 'yyyy-MM-dd',
      'br-FR': 'dd/MM/yyyy',
      'smn-FI': 'd.M.yyyy',
      'moh-CA': 'M/d/yyyy',
      'arn-CL': 'dd-MM-yyyy',
      'ii-CN': 'yyyy/M/d',
      'dsb-DE': 'd. M. yyyy',
      'ig-NG': 'd/M/yyyy',
      'kl-GL': 'dd-MM-yyyy',
      'lb-LU': 'dd/MM/yyyy',
      'ba-RU': 'dd.MM.yy',
      'nso-ZA': 'yyyy/MM/dd',
      'quz-BO': 'dd/MM/yyyy',
      'yo-NG': 'd/M/yyyy',
      'ha-Latn-NG': 'd/M/yyyy',
      'fil-PH': 'M/d/yyyy',
      'ps-AF': 'dd/MM/yy',
      'fy-NL': 'd-M-yyyy',
      'ne-NP': 'M/d/yyyy',
      'se-NO': 'dd.MM.yyyy',
      'iu-Cans-CA': 'd/M/yyyy',
      'sr-Latn-RS': 'd.M.yyyy',
      'si-LK': 'yyyy-MM-dd',
      'sr-Cyrl-RS': 'd.M.yyyy',
      'lo-LA': 'dd/MM/yyyy',
      'km-KH': 'yyyy-MM-dd',
      'cy-GB': 'dd/MM/yyyy',
      'bo-CN': 'yyyy/M/d',
      'sms-FI': 'd.M.yyyy',
      'as-IN': 'dd-MM-yyyy',
      'ml-IN': 'dd-MM-yy',
      'en-IN': 'dd-MM-yyyy',
      'or-IN': 'dd-MM-yy',
      'bn-IN': 'dd-MM-yy',
      'tk-TM': 'dd.MM.yy',
      'bs-Latn-BA': 'd.M.yyyy',
      'mt-MT': 'dd/MM/yyyy',
      'sr-Cyrl-ME': 'd.M.yyyy',
      'se-FI': 'd.M.yyyy',
      'zu-ZA': 'yyyy/MM/dd',
      'xh-ZA': 'yyyy/MM/dd',
      'tn-ZA': 'yyyy/MM/dd',
      'hsb-DE': 'd. M. yyyy',
      'bs-Cyrl-BA': 'd.M.yyyy',
      'tg-Cyrl-TJ': 'dd.MM.yy',
      'sr-Latn-BA': 'd.M.yyyy',
      'smj-NO': 'dd.MM.yyyy',
      'rm-CH': 'dd/MM/yyyy',
      'smj-SE': 'yyyy-MM-dd',
      'quz-EC': 'dd/MM/yyyy',
      'quz-PE': 'dd/MM/yyyy',
      'hr-BA': 'd.M.yyyy.',
      'sr-Latn-ME': 'd.M.yyyy',
      'sma-SE': 'yyyy-MM-dd',
      'en-SG': 'd/M/yyyy',
      'ug-CN': 'yyyy-M-d',
      'sr-Cyrl-BA': 'd.M.yyyy',
      'es-US': 'M/d/yyyy'
    };
    return formats;
  }

  getCalenderLocaleSettings(): any {
    // Todo - should be replaced by translations
    const CALENDER_CONFIG = {
      firstDayOfWeek: 6,
      dayNames: [TranslationService.translate('vbeiMonday'),
      TranslationService.translate('vbeiTuesday'),
      TranslationService.translate('vbeiWednesday'),
      TranslationService.translate('vbeiThursday'),
      TranslationService.translate('vbeiFriday'),
      TranslationService.translate('vbeiSaturday'),
      TranslationService.translate('vbeiSunday')],
      dayNamesShort: [TranslationService.translate('vbeiShortMonday'),
      TranslationService.translate('vbeiShortTuesday'),
      TranslationService.translate('vbeiShortWednesday'),
      TranslationService.translate('vbeiShortThursday'),
      TranslationService.translate('vbeiShortFriday'),
      TranslationService.translate('vbeiShortSaturday'),
      TranslationService.translate('vbeiShortSunday')],
      dayNamesMin: [TranslationService.translate('vbeiMinMonday'),
      TranslationService.translate('vbeiMinTuesday'),
      TranslationService.translate('vbeiMinWednesday'),
      TranslationService.translate('vbeiMinThursday'),
      TranslationService.translate('vbeiMinFriday'),
      TranslationService.translate('vbeiMinSaturday'),
      TranslationService.translate('vbeiMinSunday')],
      monthNames: [TranslationService.translate('vbeiJanuary'),
      TranslationService.translate('vbeiFebruary'),
      TranslationService.translate('vbeiMarch'),
      TranslationService.translate('vbeiApril'),
      TranslationService.translate('vbeiMay'),
      TranslationService.translate('vbeiJune'),
      TranslationService.translate('vbeiJuly'),
      TranslationService.translate('vbeiAugust'),
      TranslationService.translate('vbeiSeptember'),
      TranslationService.translate('vbeiOctober'),
      TranslationService.translate('vbeiNovember'),
      TranslationService.translate('vbeiDecember')],
      monthNamesShort: [TranslationService.translate('vbeiShortJanuary'),
      TranslationService.translate('vbeiShortFebruary'),
      TranslationService.translate('vbeiShortMarch'),
      TranslationService.translate('vbeiShortApril'),
      TranslationService.translate('vbeiShortMay'),
      TranslationService.translate('vbeiShortJune'),
      TranslationService.translate('vbeiShortJuly'),
      TranslationService.translate('vbeiShortAugust'),
      TranslationService.translate('vbeiShortSeptember'),
      TranslationService.translate('vbeiShortOctober'),
      TranslationService.translate('vbeiShortNovember'),
      TranslationService.translate('vbeiShortDecember')],
      today: TranslationService.translate('vbeiToday'),
      clear: TranslationService.translate('vbeiClear'),
    };

    return CALENDER_CONFIG;
  }

  formatAdditionalFieldValue(code: string, value: string, fieldType: string): string {
    const type: FieldType = this.getAdditionalFieldType(fieldType);
    switch (type) {
      case FieldType.DT:
        value = value ? this.setDate(value) + 'T' + this.setTime(value) : null;
        break;
      case FieldType.DTO:
        value = value ? this.setDate(value) : null;
        break;
      case FieldType.TMO:
        value = value ? this.setTime(value) : null;
        break;
      case FieldType.BOOL:  // Save boolean value as string
        value = value ? value.toString() : 'false';
        break;
      case FieldType.FLOAT:
        value = value ? value.replace(',', '.') : null;
        break;
      default:
        value = value ? value : null;
        break;
    }
    return value;
  }

  getAdditionalFieldType(type: string): FieldType {
    return FieldType[type] as unknown as FieldType;
  }

  public toDateTime(value: string, dateFormat: string): Date | null {
    const str = this.splitMulti(value, ['/', '-', '.']);
    const dateStr = this.splitMulti(dateFormat, ['/', '-', '.']);

    let year: any;
    let month: any;
    let date: any;
    let time: any;

    for (let i = 0; i < dateStr.length; i++) {
      if (dateStr[i] === 'MM' || dateStr[i] === 'M') {
        month = str[i];
      }

      if (dateStr[i] === 'dd' || dateStr[i] === 'd') {
        date = str[i];
      }

      if (dateStr[i] === 'yyyy' || dateStr[i] === 'yy') {
        const splitted = str[i].split(' ');
        year = splitted[0];
        time = splitted[1];
        if (!time) {
          time = '';
        }
      }
    }
    const dateString = year + '/' + month + '/' + date + ' ' + time;
    if (new Date(dateString).toString() === INVALIDDATE) {
      return null;
    } else {
      return new Date(dateString);
    }
  }

  public getLocaleDateFormat() {
    const dateFormat = this.getDateFormats();
    const culture = this.getUserCulture();
    return (culture in dateFormat) ? dateFormat[culture] : null;
  }

  public getUserCulture() {
    return sessionStorage.getItem('LanguageCode') ? sessionStorage.getItem('LanguageCode')
     : navigator.language.split('-')[0];
  }
  splitMulti(str, tokens) {
    const tempChar = tokens[0];
    for (let i = 1; i < tokens.length; i++) {
      str = str.split(tokens[i]).join(tempChar);
    }
    str = str.split(tempChar);
    return str;
  }

  public getUTCISODate(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString();
  }

  private setDate(value: string) {
    const date = new Date(value);
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
  }

  private setTime(value: string) {
    const date = new Date(value);
    return ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':00';
  }

  isLetter(value: string) {
    const val = value.trim().charAt(0);
    return val.length === 1 && val.match(/[a-z]/i);
  }

  isNumber(value: string) {
    const val = value.trim().charAt(0);
    return val.length === 1 && val.match(/[0-9]/i);
  }

  isLetterOrNumber(value: string) {
    const val = value.trim().charAt(0);
    return val.length === 1 && val.match(/[a-z0-9]/i);
  }

  public sortUnits(units: Unit[], isFrequentlyUsed = false): Unit[] {
    if (isFrequentlyUsed) {
      units.sort((x, y) => {
        if (x.serialNumber > y.serialNumber) {
          return 1
        } else {
          return -1;
        }
      });
    }
    else {
      units.sort((x, y) => {
        if (this.isLetterOrNumber(x.name[0])) {
          if (!this.isLetterOrNumber(y.name[0])) {
            // x is a letter/digit and y is not, override regular CompareTo
            return -1;
          }
        } else if (this.isLetterOrNumber(y.name[0])) {
          // y is a letter/digit and x is not, override regular CompareTo
          return 1;
        }
  
        if (this.isLetter(x.name[0])) {
          if (!this.isLetter(y.name[0])) {
            // x is a letter and y is digit, override regular CompareTo
            return -1;
          }
        } else if (this.isLetter(y.name[0])) {
          // y is a letter and x is digit, override regular CompareTo
          return 1;
        }
  
        return x.name > y.name ? 1 : -1;
      });
    }

    return units;
  }

  public getStateCode(stateName: string) {
    let stateCode = null;
    const state = states
                  .filter(s => s.name.toLowerCase().trim() === stateName.toLowerCase().trim()
                    || s.code.toLowerCase().trim() === stateName.toLowerCase().trim()).shift();
    if (state) {
       stateCode = state.code;
    }
    return stateCode;
  }
}
